import React from "react";
import { Link } from "react-router-dom";
import "./BlogCard.scss";
import { urlForImage } from "../../sanity/image";

const BlogCard = ({ blogPosts }) => {
  const wordsPerMinute = 30;
  // Calculate estimated reading time
  const contentWords = blogPosts.description?.split(" ").length;
  const readingTime = Math.ceil(contentWords / wordsPerMinute);

  const shortenedDescription =
    blogPosts.description?.length > 100 ? blogPosts.description.substring(0, 100) + `... (${readingTime} min read)` : blogPosts.description;

  return (
    <Link className="card" to={`/blogs/${blogPosts.slug.current}`} key={blogPosts._id}>
      <div className="blogs__container-card">
        <div className="blogs__container-card-img">
          <img src={urlForImage(blogPosts.coverImage).url()} alt="blog" width={392} height={240} title="Radiksez blog image" />
        </div>

        <div className="blogs__container-card-content">
          <div className="card__content-text">
            <h2>{blogPosts.title}</h2>
            <p>{shortenedDescription}</p>
          </div>

          <div className="card__content-footer">
            <div className="card__content-footer__author">
              <div className="footer__author-img">
                {blogPosts?.authorImage && (
                  <img
                    src={urlForImage(blogPosts?.authorImage).width(100).height(100).url()}
                    alt="author"
                    width={72}
                    height={72}
                    title="Radiksez blog author"
                  />
                )}
              </div>

              <div className="footer__author-text">
                <h3 className="author-name">{blogPosts.authorName}</h3>
                <p className="author-date">
                  {new Date(blogPosts.publishedAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
            </div>

            <div className="footer-read" key={blogPosts._id}>
              <button className="read-more"> Read More</button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default BlogCard;
